<template>
  <v-dialog @keydown="onKeyDown" v-model="isDialogOpened" width="1000">
    <v-card :loading="isLoading || loading" :class="`${arabic ? 'arFont' : 'enFont'}`">
      <v-card-title class="d-flex text-h5">
        <div>
          Quick review
        </div>

        <v-spacer />

        <v-btn v-if="this.currentItem + 1 < this.pendingUpdates.length || hasMorePages" @click.prevent="nextItem" text color="primary">
          <span>Next</span>
          <v-icon>arrow_right_alt</v-icon>
        </v-btn>
        <v-btn v-else @click.prevent="nextItem" icon text color="info">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="elevation-0">
        <v-card elevation="0" v-if="timeline">
          <v-card-text class="pa-0">
            <v-row justify="space-between" class="align-center">
              <v-col cols="6" class="py-1">
                <div :class="`${arabic ? 'arFont' : 'enFont'}`" style="font-size:11px;font-weight:700;">
                  {{ i18n["aramcco_code"] }}
                </div>
                <div :class="`${arabic ? 'arFont' : 'enFont'}`">{{ timeline.candidate.aramcco_code }}</div>
              </v-col>
              <v-col cols="6" class="py-1">
                <div :class="`${arabic ? 'arFont' : 'enFont'}`" style="font-size:11px;font-weight:700;">
                  {{ i18n["name"] }}
                </div>
                <div :class="`${arabic ? 'arFont' : 'enFont'}`">{{ timeline.candidate.name }}</div>
              </v-col>
              <v-col cols="6" class="py-1">
                <div :class="`${arabic ? 'arFont' : 'enFont'}`" style="font-size:11px;font-weight:700;">
                  {{ i18n["updated_field"] }}
                </div>
                <div :class="`${arabic ? 'arFont' : 'enFont'}`">{{ timeline.update_field }}</div>
              </v-col>
              <v-col cols="6" class="py-1">
                <div :class="`${arabic ? 'arFont' : 'enFont'}`" style="font-size:11px;font-weight:700;">
                  {{ i18n["updated_value"] }}
                </div>
                <div :class="`${arabic ? 'arFont' : 'enFont'}`">{{ timeline.update_value }}</div>
              </v-col>
              <v-col cols="6" class="py-1">
                <div :class="`${arabic ? 'arFont' : 'enFont'}`" style="font-size:11px;font-weight:700;">
                  {{ i18n["updated_status"] }}
                </div>
                <v-chip small v-if="timeline.pending" :class="`${arabic ? 'arFont' : 'enFont'}`">{{
                  i18n["pending"]
                }}</v-chip>
                <v-chip small color="success" v-if="timeline.approved" :class="`${arabic ? 'arFont' : 'enFont'}`">{{
                  i18n["approved"]
                }}</v-chip>
                <v-chip small color="error" v-if="timeline.rejected" :class="`${arabic ? 'arFont' : 'enFont'}`">{{
                  i18n["rejected"]
                }}</v-chip>
              </v-col>
              <v-col cols="6" class="py-1">
                <div :class="`${arabic ? 'arFont' : 'enFont'}`" style="font-size:11px;font-weight:700;">
                  {{ i18n["last_update"] }}
                </div>
                <div :class="`${arabic ? 'arFont' : 'enFont'}`">{{ getFormat(timeline.updated_at) }}</div>
              </v-col>
              <v-col cols="12" v-if="timeline.note" class="py-1">
                <div :class="`${arabic ? 'arFont' : 'enFont'}`" style="font-size:11px;font-weight:700;">
                  {{ i18n["note"] }}
                </div>
                <div :class="`${arabic ? 'arFont' : 'enFont'}`">{{ timeline.note }}</div>
              </v-col>
              <v-col cols="12" class="py-1">
                <v-textarea
                  @focus="() => (noteFieldFocused = true)"
                  @blur="() => (noteFieldFocused = false)"
                  hide-details
                  v-model="note"
                  label="Note"
                  small
                  outlined
                  class="mt-2"
                />
              </v-col>
              <v-col cols="12">
                <div class="d-flex">
                  <v-btn @click.prevent="accept" small color="success">
                    <v-icon>done</v-icon>
                    <span>Accept</span>
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn @click.prevent="reject" small color="error">
                    <v-icon>remove</v-icon>
                    <span>Reject</span>
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <div v-else class="text-center py-5">
          No pending updates to review !
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { format } from "timeago.js";

export default {
  props: {
    loading:  {
      type: Boolean,
      default: false,
    },
    hasMorePages: {
      type: Boolean,
      default: false,
    },
    dialog: {
      type: Boolean,
      default: false,
    },
    pendingUpdates: Array,
  },
  data() {
    return {
      noteFieldFocused: false,
      _note: null,
      isLoading: false,
      currentItem: 0,
    };
  },
  computed: {
    note: {
      get() {
        return this.pendingUpdates[this.currentItem].note;
      },
      set(value) {
        this._note = value;
      },
    },
    timeline() {
      return this.pendingUpdates[this.currentItem];
    },
    isDialogOpened: {
      get() {
        return this.dialog;
      },
      set(value) {
        this.$emit("closeDialog");
      },
    },
    user() {
      return this.$store.state.user;
    },
    language() {
      return this.$store.state.language;
    },
    i18n() {
      return this.$store.state.i18n[this.$store.state.language];
    },
    arabic() {
      if (this.$store.state.language == "ar") return true;
    },
  },
  methods: {
    nextItem() {
      if (this.currentItem + 1 < this.pendingUpdates.length) {
        this.currentItem = this.currentItem + 1;
      } else {
        console.log(this.hasMorePages);
        if (this.hasMorePages) {
          this.currentItem = 0
          this.$emit("nextPage");
        }
        else {
          this.$emit("closeGetResource");
        }
      }
    },
    onKeyDown(e) {
      if (e.code == "Space" && !this.noteFieldFocused) {
        e.preventDefault();
        this.nextItem();
        this._note = null;
      }
    },
    getFormat(d) {
      return format(d);
    },
    async accept() {
      await this.updateResource(true, false);
    },
    async reject() {
      await this.updateResource(false, true);
    },
    async updateResource(approved, rejected) {
      this.isLoading = true;

      await this.$store.dispatch("putResource", {
        resource: `/can/update_/updates/${this.timeline.id}`,
        value: { approved, rejected, note: this._note ? this._note : this.note },
      });

      this.nextItem();

      this.isLoading = false;
      this._note = null;
    },
  },
  expose: ["onKeyDown"],
};
</script>
